import type { IconData } from '@stacksjs/iconify-core'

export const emailTray: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M30.47 18.29h-1.52v-3.05h-1.52v-1.52H25.9V1.53h-1.52v1.52h-1.52v1.53h1.52v9.14h-9.14v-6.1h6.09V6.1H7.62v1.52h6.09v6.1h-1.52v1.52h-1.53v7.62H9.14v1.52h1.52v1.53h10.67v-1.53h-9.14v-7.61h1.52v-1.53H25.9v1.53h1.53v4.57h-4.57v1.52h7.61v1.52h-7.61v1.53h-1.53v1.52H10.66v-1.52H9.14v-1.53H1.52v-1.52h7.62v-1.52H4.57V4.58h1.52V3.05H4.57V1.53H3.05v16.76H1.52v1.52H0v10.67h1.52V32h28.95v-1.52H32V19.81h-1.53z\"/><path fill=\"currentColor\" d=\"M24.38 16.77h1.52v1.52h-1.52Zm-1.52 1.52h1.52v1.52h-1.52Zm-1.53 4.57h1.53v1.52h-1.53Zm-4.57-3.05h6.1v1.53h-6.1Zm4.57-15.23h1.53V6.1h-1.53Zm-6.09 13.71h1.52v1.52h-1.52Zm-1.53-1.52h1.53v1.52h-1.53ZM6.09 4.58h1.53V6.1H6.09ZM4.57 0h19.81v1.53H4.57Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default emailTray
